const jwtDecode = require("jwt-decode");

export const decodeToken = token => {
  if (token != null) {
    try {
      var decoded = jwtDecode(token);
    } catch {
      return null;
    }

    return decoded;
  }
  return null;
};
